<template>
  <q-dialog v-model="isOpenSync" persistent>
    <q-card style="width: 25rem; max-width: 80vw">
      <q-card-section class="row items-center justify-between q-pb-none">
        <h6>Add Help Topic</h6>
        <q-btn v-close-popup flat round dense icon="close" />
      </q-card-section>

      <q-card-section>
        <q-input
          v-model="name"
          no-error-icon
          label="Topic name"
          hint="Name of the new topic"
          error-message="Name is required"
          :error="$v.name.$error"
        />

        <q-select
          v-model="type"
          no-error-icon
          label="Topic type"
          hint="Icon representing this topic (optional)"
          error-message="Topic type is required"
          :error="$v.type.$error"
          :options="topics"
        />
      </q-card-section>

      <q-card-section>
        <p class="text-muted">Topic icon:</p>

        <div class="text-center">
          <img v-if="type" :src="topicIcon" alt="topic type" />
          <q-icon v-else name="o_info" size="xl" color="primary" />
        </div>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn v-close-popup flat color="muted" label="Cancel" />
        <q-btn color="primary" label="Create" @click="addTopic" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import required from 'vuelidate/lib/validators/required';
import { getSourceFromAsset, getErrorMessage } from '@/utils';

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      name: '',
      type: '',
      topics: ['account', 'charge', 'transfer', 'subscription', 'international', 'dispute'],
    };
  },

  computed: {
    isOpenSync: {
      get() {
        return this.isOpen;
      },
      set(value) {
        this.$emit('update:isOpen', value);
      },
    },
    topicIcon() {
      switch (this.type) {
        case 'account':
          return getSourceFromAsset('icon_myAccount.png');
        case 'charge':
          return getSourceFromAsset('icon_ChargesRefunds.png');
        case 'transfer':
          return getSourceFromAsset('icon_TransfersDeposits.png');
        case 'subscription':
          return getSourceFromAsset('icon_Subscriptions.png');
        case 'international':
          return getSourceFromAsset('icon_International.png');
        case 'dispute':
          return getSourceFromAsset('icon_DisputesFraud.png');
        default:
          return '';
      }
    },
  },

  watch: {
    isOpen() {
      if (this.isOpen === false) {
        this.name = '';
        this.type = '';
      }
    },
  },

  methods: {
    async addTopic() {
      this.$v.$reset();
      this.$v.$touch();
      if (this.$v.$invalid) return;

      try {
        await this.$axios.post('/admin/topics', { name: this.name, type: this.type });

        this.$q.notify({ message: 'New topic has been added!', type: 'positive' });
        this.isOpenSync = false;
      } catch (error) {
        this.$q.notify({ message: getErrorMessage(error), type: 'negative' });
      }
    },
  },

  validations: {
    name: {
      required,
    },
    type: {
      required,
    },
  },
};
</script>
